import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitialState {
  draw: MapboxDraw | undefined;
  drawing: boolean;
}

const initialState: InitialState = {
  draw: undefined,
  drawing: false,
};

const mapBoxDrawSlice = createSlice({
  initialState,
  name: 'mapBox',
  reducers: {
    clearDraw: (state) => {
      state.drawing = initialState.drawing;
    },
    setDrawing: (state, action: PayloadAction<boolean>) => {
      state.drawing = action.payload;
    },
    setMapBoxDraw: (state, action: PayloadAction<any>) => {
      state.draw = action.payload;
    },
  },
});

export const { setMapBoxDraw, setDrawing, clearDraw } = mapBoxDrawSlice.actions;

export default mapBoxDrawSlice.reducer;
